import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { db } from "../firebase";
import { ref, onChildAdded, push } from "firebase/database";

const ChatRoom = () => {
  const [searchParams] = useSearchParams();
  const questionId = searchParams.get("id");
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  useEffect(() => {
    const messagesRef = ref(db, `chats/${questionId}`);
    const unsub = onChildAdded(messagesRef, (snapshot) => {
      setMessages((prev) => [...prev, snapshot.val()]);
    });

    return () => {}; // 可加入 off 方法
  }, [questionId]);

  const sendMessage = () => {
    if (!input) return;

    push(ref(db, `chats/${questionId}`), {
      sender: "teacher",
      text: input,
      timestamp: Date.now(),
    });

    setInput("");
  };

  return (
    <div>
      <h2>Live Chat</h2>
      <div
        style={{
          border: "1px solid black",
          height: "300px",
          overflowY: "scroll",
        }}
      >
        {messages.map((msg, i) => (
          <div
            key={i}
            style={{ textAlign: msg.sender === "teacher" ? "right" : "left" }}
          >
            <p>
              <strong>{msg.sender}:</strong> {msg.text}
            </p>
          </div>
        ))}
      </div>

      <input value={input} onChange={(e) => setInput(e.target.value)} />
      <button onClick={sendMessage}>Send</button>
    </div>
  );
};

export default ChatRoom;
